// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import sessionVoteResultEntity from './entities/session-vote-result.json';
import sessionVoteResultMenu from '../pages/session-vote-result/menu.json';
import sessionVoteResultFullForm from '../pages/session-vote-result/forms/full.json';
import sessionVoteResultContextForm from '../pages/session-vote-result/forms/context.json';
import sessionVoteResultMiniForm from '../pages/session-vote-result/forms/mini.json';
import sessionVoteResultLookupForm from '../pages/session-vote-result/forms/lookup.json';
import sessionVoteResultTableView from '../pages/session-vote-result/views/table.json';
import sessionVoteResultCardsView from '../pages/session-vote-result/views/cards.json';
import sessionVoteResultDashboardView from '../pages/session-vote-result/views/dashboard.json';

/** Тип запису «Результат голосування» зі сторінками пакета: меню, форми та подання з pages/session-vote-result/. */
export const sessionVoteResultDefinition: IRecordTypeDefinition = {
  ...sessionVoteResultEntity,
  views: assembleViewSet({
      table: sessionVoteResultTableView,
      cards: sessionVoteResultCardsView,
      dashboard: sessionVoteResultDashboardView,
  }),
  form: sessionVoteResultFullForm,
  forms: { full: sessionVoteResultFullForm, context: sessionVoteResultContextForm, mini: sessionVoteResultMiniForm, lookup: sessionVoteResultLookupForm },
  menu: sessionVoteResultMenu,
} as IRecordTypeDefinition;
